export const ALLOW_DATE_TYPE = {
  ANY: 0,
  PAST: 1,
  FUTURE: 2,
};
